module.exports = __webpack_public_path__ + "static/media/_.9d2f4c53.svg";